export default {"src":"/_next/static/media/ic_left_gold.e5a0220e.svg","height":352,"width":192,"blurWidth":0,"blurHeight":0};